<template>
    <div class="prsearch">
        <b-container fluid>
            <b-row>
                <b-col cols="4">
                    <h1>Search:</h1>
                    <b-row>
                        <b-col cols="4">PM in charge:</b-col>
                        <b-col cols="8">
                            <multi-select
                                :options="pms"
                                :selected-options="pm"
                                @select="onMSelectP"
                            ></multi-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">Customer:</b-col>
                        <b-col cols="8">
                            <multi-select
                                :options="customers"
                                :selected-options="customer"
                                @select="onMSelectC"
                            ></multi-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">Unit:</b-col>
                        <b-col cols="8">
                            <multi-select
                                :options="knumbers"
                                :selected-options="knumber"
                                @select="onMSelectK"
                            ></multi-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <br>
                            <b-button @click="reset" variant="info">Reset</b-button>
                            &nbsp;&nbsp;&nbsp;
                            <b-button @click="search" class="search">Search</b-button>
                        </b-col>
                    </b-row>
                    <b-row v-for="machine in schede" :key="machine.codice" >
                        <b-col>
                            <SchedaMacchina :m="machine" :info="true" buttontext="MORE INFO" route="pinfomacchina" :key="upd"/>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col>
                            <div class="title">Last Updates</div>
                            <OpenPoints :filtro="selschede" :noAdd="true" height="calc(100vh - 580px)"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="title">Communications</div>
                            <LastThreadMsgs :filtro="selschede"/>
                        </b-col>
                        <b-col>
                            <div class="title">Expiring Issues</div>
                            <ExpiringIssues :filtro="selschede"/>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { API } from "@/api.js";
import SchedaMacchina from "@/components/SchedaMacchina.vue";
import OpenPoints from "@/components/OpenPoints.vue";
import ExpiringIssues from "@/components/ExpiringIssues.vue";
import LastThreadMsgs from "@/components/LastThreadMsgs.vue";
import { MultiSelect } from "vue-search-select";
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
    name: "PIIssues",
    components: {
        SchedaMacchina,
        OpenPoints,
        MultiSelect,
        ExpiringIssues,
        LastThreadMsgs,
    },
    data: function () {
        return {
            pm: [],
            customer: [],
            knumber: [],
            filter: [],
            pms: [],
            customers: [],
            knumbers: [],
            schede: [],
            upd: 0,
        }
    },
    props: {
        
    },
    async mounted(){
        this.pms = (await API.getPMs(this.section)).map(pm => ({value: pm.id, text: pm.name + " " + pm.surname + " (" + pm.cname + ")"}));
        this.customers = (await API.getCustomers(this.section)).map(c => ({value: c.code ? c.code : 0, text: c.cname}));
        this.filter = (await API.getKNumbers(this.section))
        this.knumbers = this.filter.map(k => ({value: k.unit, text: k.unit}));
    },
    computed: {
        section(){
            return this.$store.getters.section
        },
        selschede(){
            return this.schede.map(s => s.codice)
        }
    },
    methods: {
        onMSelectK(items) {
            console.log("ITEMS",items);
            this.knumber = items
        },
        onMSelectP(items) {
            console.log("ITEMS",items);
            this.pm = items
        },
        onMSelectC(items) {
            console.log("ITEMS",items);
            this.customer = items
        },
        reset(){
            console.log("reset")
            this.pm = [];
            this.customer = [];
            this.knumber = [];
            this.schede = [];
        },
        filtra(u){
            let res = true;
            let ok = this.pm.length == 0;
            for(let tp of this.pm.map(p => p.value)){
                // elenco dei k che hanno tp tra i pms
                let pm = this.filter.filter(f => f.pms.includes(tp)).map(f => f.unit);
                ok |= pm.includes(u.code);
            }
            res &= ok
            ok = this.customer.length == 0;
            for( let tc of this.customer.map(p => p.value)){
                ok |= u.client_code == tc;
            }
            res &= ok
            ok = this.knumber.length == 0;
            for( let tk of this.knumber.map(p => p.value)){
                ok |= u.code == tk;
            }
            res &= ok
            return res;
        },
        async search(){
            console.log("search",this.pm,this.customer,this.knumber)
            let unitNames = await API.getUnitNames();
            let pi_units = (await API.getPrInUnits(this.section)).map(u => u.unit_code)
            let data = await API.getUnits(false,this.section);
            console.log("filter",this.filter)
            console.log("data",data)
            this.schede = data
                            .filter(u => pi_units.includes(u.code))
                            .filter(u => this.filtra(u))
                            .map((d) => ({
                client: d.client_code,
                nome: d.name,
                codice: d.code,
                location: d.location,
                img: d.img,
                macchina: d.macchina,
                descr: d.descr,
                delivered: d.delivered,
                label_info: d.label_info,
                upd: 0,
                nomepers: (unitNames.find(u => u.code==d.code) || {}).name || d.name,
                locationpers: (unitNames.find(u => u.code==d.code) || {}).location || d.location
            })); // upd serve per l'aggiornamento delle immagini
            console.log("schede",this.schede)
            this.$nextTick(async () => {
			let k = 1;
			for (let s of this.schede) {
				s.image = "/images/units/" + s.img;
				s.upd = k++;
                this.upd++
			}
		});
        }
    }
}

</script>
<style>
div.prsearch div.card {
    margin: 0px !important;
}
</style>
<style scoped>
div.title {
    text-align: left;
    font-weight: 700;
}
div.prsearch {
    padding: 10px;
    padding-top: 10px;
    background-color: #d3d3d3;
}
div.prsearch button {
	margin-bottom: 10px;
}
div.prsearch button.search {
	background-color: #9a240d !important;
	border-color: #9a240d !important;
}
div.prsearch button.search:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.prsearch button.search:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.title {
    /* text-align: left; */
    font-weight: 700;
    background-color: white;
}
</style>
